import { composeIO } from 'react-compose-io'
import { modalRegularizacaoCiclosIO } from './ModalRegularizacaoCiclos.IO'
import { ModalRegularizacaoCiclosView } from './ModalRegularizacaoCiclos.View'

export const ModalRegularizacaoCiclos = composeIO(ModalRegularizacaoCiclosView, modalRegularizacaoCiclosIO)
